import React, { useContext, useEffect, useState } from 'react';
import { FaFacebookF, FaGoogle, FaInstagram, FaShoppingCart, FaTwitter, FaWhatsapp } from 'react-icons/fa';
import { CartContext } from '../Cart/CartContext';
import { Link } from 'react-router-dom';
import ContactModal from './ContactModal';

const Footer = () => {
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  const { cartItems } = useContext(CartContext);
  const [open, setOpen] = useState(false);
  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const getCartItemCount = () => {
    return cartItems.reduce((total, item) => total + item.quantity, 0);
  };



  /// this is categorys

  
      const [categoriesp, setCategoriesp] = useState([]);

   useEffect(() => {
          fetch('https://api.glocart.in/pages/api/api/categories')
              .then(res => res.json())
              .then(data => {
                  // Ensure we only store an array
                  const categoriesArray = Array.isArray(data) ? data : (Array.isArray(data.data) ? data.data : []);
                  setCategoriesp(categoriesArray);
              })
              .catch(err => console.error('Error fetching categories:', err));
  
       
      }, []);

      console.log('this is categorie',categoriesp)

  return (
    <footer className='mt-5' style={{ maxWidth: '1200px', margin: '0 auto', fontFamily: 'Arial, sans-serif', color: '#000', padding: '0 10px' }}>
      {/* Top Contact Strip */}
      <div style={{ backgroundColor: '#0058A2', color: '#fff', padding: '20px', borderRadius: '10px', display: 'flex', flexDirection: isMobile ? 'column' : 'row', alignItems: 'center', justifyContent: 'space-between', gap: '15px' }}>
        <p style={{ margin: 0, fontWeight: 'bold' }}>BE IN TOUCH WITH US:</p>

        <div style={{ display: 'flex', flexDirection: isMobile ? 'column' : 'row', width: isMobile ? '100%' : 'auto', alignItems: 'center', gap: '10px', flex: 1 }}>
          <input placeholder="Enter your e-mail" style={{ padding: '10px', borderRadius: '4px', border: 'none', outline: 'none', flex: 1, width: isMobile ? '100%' : 'auto' }} />
          <button style={{
            padding: '10px 16px',
            backgroundColor: '#fff',
            color: '#0058A2',
            border: 'none',
            borderRadius: '4px',
            fontWeight: 'bold',
            cursor: 'pointer',
            width: isMobile ? '100%' : 'auto'
          }}>
            Join Us
          </button>
        </div>
{/* 
        <div style={{ fontSize:"25px",display: 'flex', gap: '10px', justifyContent: isMobile ? 'center' : 'flex-end', width: isMobile ? '100%' : 'auto' }}>
          <FaFacebookF style={{ cursor: 'pointer' }} />
          <FaTwitter style={{ cursor: 'pointer' }} />
          <FaGoogle style={{ cursor: 'pointer' }} />
          <FaInstagram style={{ cursor: 'pointer' }} />
          <FaWhatsapp style={{ cursor: 'pointer' }} />
        </div> */}

        <div
  style={{
    fontSize: "25px",
    display: 'flex',
    gap: '10px',
    justifyContent: isMobile ? 'center' : 'flex-end',
    width: isMobile ? '100%' : 'auto'
  }}
>
  <a
    href="https://www.facebook.com/shreenathfoods"
    target="_blank"
    rel="noopener noreferrer"
  >
    <FaFacebookF style={{ cursor: 'pointer', color: '#ffffffff' }} />
  </a>

  <a
    href="https://twitter.com/shreenathfoods"
    target="_blank"
    rel="noopener noreferrer"
  >
    <FaTwitter style={{ cursor: 'pointer', color: '#ffffffff' }} />
  </a>

  <a
    href="https://www.google.com/search?q=Shreenath+Foods"
    target="_blank"
    rel="noopener noreferrer"
  >
    <FaGoogle style={{ cursor: 'pointer', color: '#ffffffff' }} />
  </a>

  <a
    href="https://www.instagram.com/shreenathfoods"
    target="_blank"
    rel="noopener noreferrer"
  >
    <FaInstagram style={{ cursor: 'pointer', color: '#ffffffff' }} />
  </a>

  <a
    href="https://wa.me/919885019299"
    target="_blank"
    rel="noopener noreferrer"
  >
    <FaWhatsapp style={{ cursor: 'pointer', color: '#25D366' }} />
  </a>
</div>

      </div>

      {/* Main Footer Grid */}
      <div style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'space-between', marginTop: '0px', rowGap: '30px' }}>
        {/* About Us */}
        {/* <div style={{ flex: '1 1 240px', minWidth: '240px' }}>
          <h3 style={{ fontWeight: 'bold', marginBottom: '15px' }}>ABOUT US</h3>
          <p>Shreenath Agencies as a cluster of various sectors have started in the year 1999 by Maanoj Thakker (Founder of Shree Swastik Agencies).</p>
          <button style={{ backgroundColor: '#0058A2', color: '#fff', border: '1px solid yellow', padding: '10px 20px', borderRadius: '5px', fontSize: '14px', marginTop: '10px', cursor: 'pointer' }}>
            Read More
          </button>
        </div> */}


        {/* <div style={{ flex: '1 1 200px', minWidth: '200px' }}>
          <h3 style={{ fontWeight: 'bold', marginBottom: '15px' }}>QUICK LINKS</h3>
          <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
            {['Home', 'Beverage', 'Food', 'Baking', 'Seasonings', 'Imported Food', 'Contact'].map((item, idx) => (
              <li key={idx} style={{ marginBottom: '8px' }}>
                <a href={`/food/${item.toLowerCase().replace(/\s+/g, '-')}`} style={{ color: '#000', textDecoration: 'none' }}>
                  {item}
                </a>
              </li>
            ))}
          </ul>
        </div>

       
        <div style={{ flex: '1 1 200px', minWidth: '200px' }}>
          <h3 style={{ fontWeight: 'bold', marginBottom: '15px' }}>INFORMATION</h3>
          <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
            {['About Us', 'Terms of Service', 'Return Policy', 'Privacy Policy', 'Shipping Terms'].map((item, idx) => (
              <li key={idx} style={{ marginBottom: '8px' }}>
                <a href={`/${item.toLowerCase().replace(/\s+/g, '-')}`} style={{ color: '#000', textDecoration: 'none' }}>
                  {item}
                </a>
              </li>
            ))}
          </ul>
        </div>

        
        <div style={{ flex: '1 1 250px', minWidth: '250px' }}>
          <h3 style={{ fontWeight: 'bold', marginBottom: '15px' }}>CONTACT US</h3>
          <p><strong>GloCart</strong></p>
          <p>
            ADDRESS: Shop No 6, 6-3-10/2, Balanagar, Behind Vilamtheater,
            Hyderabad, Telangana 500042 India.
          </p>
          <p>PHONE: <a href="tel:+919885019299" style={{ color: '#000' }}>+91 9885019299</a></p>
          <p>E-MAIL: <a href="mailto:onlinesales@shreenathfoods.com" style={{ color: '#920e0e' }}>
            onlinesales@shreenathfoods.com
          </a>
          </p>
        </div> */}
        <div style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'flex-start',
          padding: '20px',
          flexWrap: 'wrap'
        }}>

          {/* LEFT SIDE */}
          <div  style={{ flex: 1 }}>
            {/* <p>
              <strong>QUICK LINKS:</strong>{' '}
              {['Home', 'Beverage', 'Food', 'Baking', 'Seasonings', 'Imported Food', 'Contact']
                .map((item, i) => (
                  <span key={i}>
                    <a
                      href={`/food/${item.toLowerCase().replace(/\s+/g, '-')}`}
                      style={{ color: '#000', textDecoration: 'none' }}
                    >
                      {item}
                    </a>
                    {i < 6 && ', '}
                  </span>
                ))}
            </p> */}

            <p>
  <strong>QUICK LINKS:</strong>{' '}
  {categoriesp.map((category, i) => (
    <span key={category.id}>
      <a
        href={`/categories/${encodeURIComponent(category.name)}`}
        style={{ color: '#000', textDecoration: 'none' }}
      >
        {category.name}
      </a>
      {i < categoriesp.length - 1 && ', '}
    </span>
  ))}
</p>


            <p>
              <strong>INFORMATION:</strong>{' '}
              {['About Us', 'Terms of Service', 'Return Policy', 'Privacy Policy', 'Shipping Terms']
                .map((item, i) => (
                  <span key={i}>
                    <a
                      href={`/${item.toLowerCase().replace(/\s+/g, '-')}`}
                      style={{ color: '#000', textDecoration: 'none' }}
                    >
                      {item}
                    </a>
                    {i < 4 && ', '}
                  </span>
                ))}
            </p>
          </div>

          {/* RIGHT SIDE */}
          <div style={{
            width: '180px',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center'
          }}>
            <button
              onClick={() => setOpen(true)}
              style={{
                padding: '10px 20px',
                background: '#920e0e',
                color: '#fff',
                borderRadius:'5px',
                border: '',
                cursor: 'pointer'
              }}
            >
              Contact Us
            </button>
          </div>
        </div>

        {/* MODAL */}
        {open && <ContactModal onClose={() => setOpen(false)} />}
      </div>

      {/* Footer Note */}
      <div style={{ borderTop: '1px solid #ddd', textAlign: 'center', fontSize: '13px', padding: '20px 0', marginTop: '0px' }}>
        © GloCart 2026. All Rights Reserved. Developed & SEO by E-MEDHA TECHNOLOGIES - HYDERABAD.
      </div>

      {/* Floating Cart Icon */}
      {/* <Link to="/cart" style={{ textDecoration: 'none' }}>
        <div style={{
          position: 'fixed',
          bottom: '20px',
          right: '20px',
          backgroundColor: '#0058A2',
          color: '#fff',
          borderRadius: '50%',
          width: '60px',
          height: '60px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          zIndex: 999,
          boxShadow: '0 4px 12px rgba(0,0,0,0.3)',
          cursor: 'pointer'
        }}>
          <FaShoppingCart size={24} />
          {getCartItemCount() > 0 && (
            <span style={{
              position: 'absolute',
              top: '-5px',
              right: '-5px',
              backgroundColor: 'red',
              color: 'white',
              fontSize: '11px',
              padding: '2px 6px',
              borderRadius: '50%'
            }}>
              {getCartItemCount()}
            </span>
          )}
        </div>
      </Link> */}
    </footer>
  );
};

export default Footer;
